import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

const defaultFilter = {};

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/targets/activityLog/$id/')({
  validateSearch: zodValidator(withDefaults(schema.TARGETS, defaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
});
